interface ReframeProps {
  embed: string;
}

/**
 * Used to display embeds with aspect ratio
 * Try to detect width and height from the embed code otherwise fallback to 16x9
 * @param embed - Embed code
 */
const Reframe = ({ embed }: ReframeProps) => {
  const width = Number(embed?.match(/width="(\d+)"/)?.[1] || 16);
  const height = Number(embed?.match(/height="(\d+)"/)?.[1] || 9);

  return (
    <div
      className='embeed relative w-full'
      dangerouslySetInnerHTML={{ __html: embed }}
      style={{ aspectRatio: `${width}/${height}` }}
    />
  );
};

Reframe.displayName = "Reframe";

export { Reframe };
